module.exports = __webpack_public_path__ + "static/img/zhangjiagangpu.3b81ca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhangjiagangpu.png
// module id = aCV8
// module chunks = 1